export default __webpack_public_path__ + "static/6_9-0d28518f70886e6a6cd2ca8ff8f643b3.png";